import type { PlayerProfile } from '@swiss-magic/shared-types';

/**
 * A blank player_profiles row is auto-created at registration, so a row
 * existing no longer means the user has set up their profile. Treat a
 * profile as "created" only once it carries a name — the gates that funnel
 * users through profile creation before enrolling / accepting an invite
 * rely on this distinction.
 */
export function hasCreatedProfile(
  profile: PlayerProfile | null | undefined,
): boolean {
  return !!profile && !!(profile.firstName?.trim() || profile.lastName?.trim());
}
